import { render, staticRenderFns } from "./warningparam.vue?vue&type=template&id=71491382&scoped=true&"
import script from "./warningparam.vue?vue&type=script&lang=js&"
export * from "./warningparam.vue?vue&type=script&lang=js&"
import style0 from "./warningparam.vue?vue&type=style&index=0&id=71491382&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71491382",
  null
  
)

export default component.exports